import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import VisibilityIcon from "@mui/icons-material/Visibility";
import {
  fetchLateralityObject,
  hidePreviousValues,
  showPreviousValues,
} from "../Views/DCMViewer/utils/dicom_utils";
import { useSelector } from "react-redux";
import Button from "@mui/material/Button";
import { useState } from "react";

const PreviousData = ({ formData, optUrl }) => {
  const [previousValuesVisible, setpreviousValuesVisible] = useState(false);
  const dicom_data = useSelector((state) => state.dcm);
  const lateralityValue = fetchLateralityObject(dicom_data)?.Value;

  const onToogleButton = () => {
    if (previousValuesVisible) {
      hidePreviousValues(formData?.previous_visit_data);
    } else {
      showPreviousValues(formData, lateralityValue);
    }

    setpreviousValuesVisible((prev) => !prev);
  };

  return lateralityValue ? (
    <div
      style={{
        marginTop: "15px",
        marginBottom: "15px",
        display: "flex",
        flexDirection: "row",
        justifyContent: "flex-end",
      }}
    >
      <Button
        variant="outlined"
        color="primary"
        onClick={onToogleButton}
        startIcon={
          previousValuesVisible ? <VisibilityOffIcon /> : <VisibilityIcon />
        }
      >
        {previousValuesVisible ? "Hide " : "Show "}
        History
      </Button>
    </div>
  ) : null;
};

export default PreviousData;
